import React, { useState, useEffect } from "react";
import { checkResult, createFilePath, createSelectOption } from "@/common";
import { useWatchState } from "@/store";
import { BaseService, uploadUrl } from "@/service";
import { FileList, Upload } from "@/components";
import BraftEditor from "braft-editor";
import { toArr } from "@/utils";
import { Modal, Popconfirm, message, Divider, Button, Icon, Collapse, Form, Col, Row, Input, Select } from "antd";
import moment from "moment";

const { Panel } = Collapse;
const NAME = "projectItem";

const App = Form.create({ name: 'register' })((props) => {
    const { getFieldDecorator } = props.form;

    const [loading, setLoading] = useState(false);
    const [[IS_REGION], [{ IS_LOGIN, info }]] = useWatchState(["IS_REGION", "user",]);
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME])
    const { title = "", show, hide, width = 1000, DetailId, contrast, callback, } = modalProps;
    const [data, setData] = useState([]);
    const [establish_date, setEstablish_date] = useState('');
    const [province_names, setProvince_names] = useState([]);
    const [scopes, setScopes] = useState([]);
    const [scope, setScope] = useState(null);
    const [orgRec_ids, setOrgRec_ids] = useState([]);
    const [files, setFiles] = useState([]);
    const [orgRec_id, setOrgRec_id] = useState(null);
    const [personRec_ids, setPersonRec_ids] = useState([]);
    const [personRec_id, setPersonRec_id] = useState(null);
    const [state, setState] = useState(null);
    const [profile, setProfile] = useState('');
    const { Option, OptGroup } = Select;
    const InputGroup = Input.Group;
    const { TextArea } = Input;


    const formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
    };

    //const onChangeOrg_name = e => setOrg_name(e.target.value)


    useEffect(() => {
        if (DetailId) getEditRecord(DetailId)
    }, [DetailId])

    const getEditRecord = project_id => {
        BaseService.list({
            table: "thtt_project",
            where: {
                id: project_id,
                "thtt_project.is_delete": 0,
            },
            process: {
                name: "files",
                key: "id",
                targetKey: "item_id",
                params: {
                    table: "thtt_attachment_relation",
                },
            },
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            const profile = BraftEditor.createEditorState(data.profile);
            const files = data.files;
            setFiles(data.files)
            setProfile(profile);
            setData(data);
        })
    }

    const getScopeList = async () => {
        const res = await BaseService.list({
            table: "thtt_scope",
            columns: ("name,id"),
            where: {
                patent_classify_names: "产业方向",
            },
        }).then(res => {
            if (!checkResult(res)) return;
            setScopes(res.data.result);
        })
    }
    useEffect(() => { getScopeList() }, [])

    async function getPosCode() {
        const res = await BaseService.list({
            table: "thtt_china",
            where: {
                level: 1,
                pid: 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            setProvince_names(res.data.result)
        });
    }
    useEffect(() => { getPosCode() }, [])

    async function getOrgRecList() {
        const res = await BaseService.list({
            table: "thtt_project_recommend",
            columns: ("org_name,id"),
            where: {
                identify: "1",
            },
            order: ["org_category Asc"],
        }).then(res => {
            if (!checkResult(res)) return;
            setOrgRec_ids(res.data.result);
        })
    }
    useEffect(() => { getOrgRecList() }, [])

    async function getPersonRecList() {
        const res = await BaseService.list({
            table: "thtt_project_recommend",
            columns: ("org_name,id"),
            where: {
                identify: "2",
            },
            order: ["org_category Asc"],
        }).then(res => {
            if (!checkResult(res)) return;
            setPersonRec_ids(res.data.result);
        })
    }
    useEffect(() => { getPersonRecList() }, [])

    function onChangeDate(date, dateString) {
        setEstablish_date(date.format("YYYY-MM-DD"));
    }

    const onChangeProfile = (e) => {
        modalProps.profile = e;
        setProfile(modalProps.profile.toHTML());
    };


    const onUploadFileFinish = (type, e) => {
        const size = e.file.size;
        const add_time = new Date().format("yyyy-MM-dd hh:mm:ss");
        const newFiles = e.file.response.files.map(({ fileShowName, suffix, url }) => ({ type, item_id: DetailId, file_name: fileShowName, file_path: url, file_suffix: suffix, size, add_time }));
        if (!modalProps.files) modalProps.files = files;
        if (!modalProps.files[type]) modalProps.files[type] = newFiles;
        else modalProps.files[type] = modalProps.files[type].concat(newFiles);
        setProps({ ...modalProps });
    }

    const onRemoveFile = (id) => {
        BaseService.remove({
            table: "thtt_attachment_relation",
            where: { id:id }
        }).then(res => {
            if (!checkResult(res)) return;
            refeshFile();
        })
    }

    const refeshFile = async () => {
        const fileRes = await BaseService.list({
            table: "thtt_attachment_relation",
            where: { item_id:DetailId, is_delete: 0 },
        })
        const files = fileRes.data.result;
        setFiles(files);
    }


    const onSubmit = async (e) => {
        e.preventDefault();
        const update_date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        props.form.validateFieldsAndScroll(async (err, values) => {
            let _files = []
            Object.values(files).forEach((arr) => (_files = _files.concat(arr)));
            await BaseService.remove({
                table: "thtt_attachment_relation",
                where: {
                    item_id: data.id,
                    type: JSON.stringify(Object.keys(files)),
                },
            });
            await BaseService.adds({
                table: "thtt_attachment_relation",
                data: JSON.stringify(_files),
            });
            console.log("_files", JSON.stringify(_files))

            if (!err) {
                setLoading(true);
                const res = await BaseService.put({
                    table: "thtt_project", data: {
                        org_name: values.org_name,
                        establish_date: values.establish_date,
                        org_province_name: values.org_province_name,
                        industrial: values.industrial,
                        business: values.business,
                        org_person: values.org_person,
                        org_leader: values.org_leader,
                        name: values.name,
                        profile: modalProps.profile.toHTML(),
                        scope: values.scope,
                        height: values.height,
                        attribute: values.attribute,
                        achievement: values.achievement,
                        shape: values.shape,
                        scale: values.scale,
                        expect: values.expect,
                        difficulty: values.difficulty,
                        degree: values.degree,
                        strength: values.strength,
                        trl1_9: values.trl1_9,
                        leader_name: values.leader_name,
                        leader_education: values.leader_education,
                        leader_title: values.leader_title,
                        team_person: values.team_person,
                        team_intermediate: values.team_intermediate,
                        team_experience: values.team_experience,
                        orgRec_id: values.orgRec_id,
                        personRec_id: values.personRec_id,
                        update_date: update_date
                    }, where: { id: data.id }
                });

                setLoading(false);
                if (!checkResult(res)) return;
                message.success("修改成功！");
                if (callback) callback();
                hide();
            }
        });

    }

    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={onSubmit}>
                <Collapse defaultActiveKey={['1']}>
                    <Panel header="修改申报项目信息登记表" key="1">
                        <div style={{ textAlign: "center" }}>
                            <h2>科技成果转化项目双推双促工程</h2>
                            <h2>《申报项目信息登记表》</h2>
                        </div>
                        <Divider>申报单位信息</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={15}>
                                <Form.Item label="申报单位名称" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('org_name', {
                                        initialValue: data.org_name,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入申报单位名称',
                                            },
                                        ],
                                    })(<Input placeholder="请输入申报单位名称" style={{ width: 300 }} />)}
                                </Form.Item>
                            </Col>
                            <Col span={9}>
                                <Form.Item label="单位成立时间" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator("establish_date", {
                                        initialValue: (data.establish_date!=='null')?toArr(data.establish_date):''
                                    })(
                                        <Input placeholder="日期格式：2024-06-06" value={data.establish_date} style={{ width: "180px" }} />
                                    )} </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24} type="flex">
                            <Col span={8} >
                                <Form.Item label="单位所在省/市" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator("org_province_name", {
                                        initialValue: toArr(data.org_province_name),
                                        rules: [
                                            {
                                                required: true,
                                                message: "-请选择省份-",
                                            },
                                        ],
                                    })(<Select placeholder="-请选择省份-" style={{ width: "130px" }}>
                                        {province_names.map((item) => {
                                            return (<Option value={item.name}>{item.name}</Option>)
                                        })}
                                    </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8} >
                                <Form.Item label="单位产业属性" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('industrial', {
                                        initialValue: String(data["industrial"]) || undefined
                                    })(
                                        <Select placeholder="-请选择-" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "大专院校科研院所", value: "1" },
                                                { label: "社会专业研发机构", value: "2" },
                                                { label: "大型头部企业集团", value: "3" },
                                                { label: "创新创业中小企业", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8} >
                                <Form.Item label="单位业务属性" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('business', {
                                        initialValue: String(data["business"]) || undefined
                                    })(
                                        <Select placeholder="-请选择-" className="ml7" style={{ width: "100px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "研究开发", value: "1" },
                                                { label: "生产制造", value: "2" },
                                                { label: "市场营销", value: "3" },
                                                { label: "科技服务", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24} type="flex">
                            <Col span={8}>
                                <Form.Item label="单位从业人数（人)" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('org_person', {
                                        initialValue: data.org_person
                                    })(<Input placeholder="请输入单位从业人数" className="ml7 width100" style={{ width: 150 }} />)}
                                </Form.Item>
                            </Col>
                            <Col span={16} >
                                <Form.Item label="单位负责人姓名" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('org_leader', {
                                        initialValue: data.org_leader
                                    })(<Input placeholder="请输入单位负责人姓名" style={{ width: 180 }} />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider>申报项目信息</Divider>
                        <Form.Item label="申报项目名称" {...formItemLayout} >
                            {getFieldDecorator('name', {
                                initialValue: data.name,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入申报项目名称',
                                    },
                                ],
                            })(<Input placeholder="请输入申报项目名称" style={{ width: 700 }} />)}
                        </Form.Item>
                        <Row gutter={18} type="flex">
                            <Col span={9} className="ml35">
                                <Form.Item label="项目所属领域" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator("scope", {
                                        initialValue: toArr(data.scope),
                                        rules: [
                                            {
                                                required: true,
                                                message: "请选择项目所属领域",
                                            },
                                        ],
                                    })(<Select placeholder="请选择项目所属领域" style={{ width: "180px" }} >
                                        {scopes.map((item) => {
                                            return (<option value={item.id}>{item.name}</option>)
                                        })}
                                    </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item label="项目简介" {...formItemLayout} required>
                            <BraftEditor
                                className="border bor-ra-xs"
                                value={profile}
                                onChange={onChangeProfile}
                                placeholder={`请输入项目简介`} />
                        </Form.Item>
                        
                        <Divider>技术创新亮点(<span style={{ color: "red" }}>技术创新高度按项目所得最高荣誉选择</span>)</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={8} >
                                <Form.Item label="技术创新高度" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('height', {
                                        initialValue: String(data["height"]) || undefined
                                    })(
                                        <Select placeholder="请选择技术创新高度" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "国际领先", value: "1" },
                                                { label: "国际先进", value: "2" },
                                                { label: "国内先进", value: "3" },
                                                { label: "国内空白", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8} >
                                <Form.Item label="技术创新属性" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('attribute', {
                                        initialValue: String(data["attribute"]) || undefined
                                    })(
                                        <Select placeholder="请选择技术创新属性" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "重大自主原创技术", value: "1" },
                                                { label: "产业关键核心技术", value: "2" },
                                                { label: "国际前沿引领技术", value: "3" },
                                                { label: "新兴产业支撑技术", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8} >
                                <Form.Item label="技术创新成果" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('achievement', {
                                        initialValue: String(data["achievement"]) || undefined
                                    })(
                                        <Select placeholder="请选择创新成果" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "国际发明专利", value: "1" },
                                                { label: "国家发明专利", value: "2" },
                                                { label: "国家科技奖项", value: "3" },
                                                { label: "行业领军产品", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider>市场价值要点</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={11} className="ml7">
                                <Form.Item label="核心产品市场形态" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('shape', {
                                        initialValue: String(data["shape"]) || undefined
                                    })(
                                        <Select placeholder="请选择核心产品市场形态" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "软件硬件材料", value: "1" },
                                                { label: "小型仪器装置", value: "2" },
                                                { label: "大型机械装备", value: "3" },
                                                { label: "系统应用平台", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="项目已实现市场规模" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('scale', {
                                        initialValue: String(data["scale"]) || undefined
                                    })(
                                        <Select placeholder="请选择项目已实现市场规模" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "年创收十亿以上", value: "1" },
                                                { label: "年创收一亿以上", value: "2" },
                                                { label: "年创收千万以上", value: "3" },
                                                { label: "年创收千万以下", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24} type="flex">
                            <Col span={11}>
                                <Form.Item label="项目未来市场预期" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('expect', {
                                        initialValue: String(data["expect"]) || undefined
                                    })(
                                        <Select placeholder="请选择项目未来市场预期" style={{ width: "200px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "未来市场千亿级", value: "1" },
                                                { label: "未来市场百亿级", value: "2" },
                                                { label: "未来市场十亿级", value: "3" },
                                                { label: "未来市场亿元级", value: "4" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider>转化要素难点</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={11} className="ml7">
                                <Form.Item label="转化所需资源难度" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('difficulty', {
                                        initialValue: String(data["difficulty"]) || undefined
                                    })(
                                        <Select placeholder="请选择转化所需资源难度" style={{ width: "200px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "资源复杂难度很大", value: "1" },
                                                { label: "资源较多难度一般", value: "2" },
                                                { label: "资源条件难度不大", value: "3" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={11} className="ml27">
                                <Form.Item label="转化资源到位程度" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('degree', {
                                        initialValue: String(data["degree"]) || undefined
                                    })(
                                        <Select placeholder="请选择转化资源到位程度" style={{ width: "220px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "所需资源全部到位", value: "1" },
                                                { label: "有缺口有计划安排", value: "2" },
                                                { label: "缺口较大需要帮助", value: "3" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24} type="flex">
                            <Col span={11} className="ml7">
                                <Form.Item label="转化项目投资力度" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('strength', {
                                        initialValue: String(data["strength"]) || undefined
                                    })(
                                        <Select placeholder="请选择转化项目投资力度" style={{ width: "220px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "投资很大已经到位", value: "1" },
                                                { label: "有缺口有计划安排", value: "2" },
                                                { label: "缺口较大需要帮助", value: "3" },
                                                { label: "其它", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={11} className="ml7">
                                <Form.Item label="转化项目已实现进程" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('trl1_9', {
                                        initialValue: String(data["trl1_9"]) || undefined
                                    })(
                                        <Select placeholder="请选择TRL1-9" style={{ width: "220px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "技术方案设计", value: "1" },
                                                { label: "建成实验装置", value: "2" },
                                                { label: "完成概念验证", value: "3" },
                                                { label: "完成产品设计", value: "4" },
                                                { label: "完成产品中试", value: "5" },
                                                { label: "成功应用案例", value: "6" },
                                                { label: "实现生产制造", value: "7" },
                                                { label: "进入市场营销", value: "8" },
                                                { label: "建成产业体系", value: "9" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider>项目研发负责人</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={8} >
                                <Form.Item label="研发负责人姓名" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('leader_name', {
                                        initialValue: data.leader_name
                                    })(<Input placeholder="请输入项目研发负责人姓名" style={{ width: 220 }} />)}
                                </Form.Item>
                            </Col>
                            <Col span={8} >
                                <Form.Item label="学历" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('leader_education', {
                                        initialValue: String(data["leader_education"]) || undefined
                                    })(
                                        <Select placeholder="请选择学历" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "博士研究生", value: "1" },
                                                { label: "硕士研究生", value: "2" },
                                                { label: "大学本科", value: "3" },
                                                { label: "大专", value: "4" },
                                                { label: "中专", value: "5" },
                                                { label: "高中", value: "6" },
                                                { label: "其它", value: "7" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8} >
                                <Form.Item label="职称" type="flex" style={{ width: 700 }}>
                                    {getFieldDecorator('leader_title', {
                                        initialValue: String(data["leader_title"]) || undefined
                                    })(
                                        <Select placeholder="请选择职称" style={{ width: "130px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "高级职称", value: "1" },
                                                { label: "中级职称", value: "2" },
                                                { label: "初级职称", value: "3" },
                                                { label: "无", value: "4" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider>项目研发团队</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={7} >
                                <Form.Item label="团队人数" type="flex" className="ml7" style={{ width: 700 }}>
                                    {getFieldDecorator('team_person', {
                                        initialValue: String(data["team_person"]) || undefined
                                    })(
                                        <Select placeholder="请选择团队人数" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "10人以上（含）", value: "1" },
                                                { label: "10人以下", value: "2" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={9} >
                                <Form.Item label="中级以上人员占比" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('team_intermediate', {
                                        initialValue: String(data["team_intermediate"]) || undefined
                                    })(
                                        <Select placeholder="请选择中级以上人员占比" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "50%以上（含）", value: "1" },
                                                { label: "50%以下", value: "2" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8} >
                                <Form.Item label="团队合作经验" type="flex" style={{ width: 800 }}>
                                    {getFieldDecorator('team_experience', {
                                        initialValue: String(data["team_experience"]) || undefined
                                    })(
                                        <Select placeholder="请选择团队合作经验" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "0" },
                                                { label: "2年以上（含）", value: "1" },
                                                { label: "2年以下", value: "2" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider>*请选择您所提交项目的推荐单位/推荐个人（如无推荐单位/推荐个人，请选双推双促工程办公室）</Divider>
                        <InputGroup compact style={{ textAlign: "center" }}>
                            {getFieldDecorator("orgRec_id", {
                                initialValue: toArr(data.orgRec_id),
                                rules: [
                                    {
                                        required: true,
                                        message: "请选择推荐单位",
                                    },
                                ],
                            })(
                                <Select defaultValue="请选择推荐单位" style={{ width: '45%' }} value={data.orgRec_id}>
                                    {orgRec_ids.map((item) => {
                                        return (<Option value={item.id}>{item.org_name}</Option>)
                                    })}
                                </Select>
                            )}<p style={{ marginLeft: 20, marginRight: 20 }}>或</p>
                            {getFieldDecorator("personRec_id", {
                                initialValue: ((data.personRec_id) === 'null' ? '已选择推荐单位' : toArr(data.personRec_id)),
                                rules: [
                                    {
                                        required: true,
                                        message: "请选择推荐个人",
                                    },
                                ],
                            })(
                                <Select defaultValue="请选择推荐个人" style={{ width: '45%' }}>
                                    {personRec_ids.map((item) => {
                                        return (<Option value={item.id}>{item.org_name}</Option>)
                                    })}
                                </Select>
                            )}
                        </InputGroup>
                        <Divider>项目申报附件目录</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={15} className="upload_list">
                                <ul>
                                    <li className="list_title">1、企业相关证明</li>
                                    <li>（1）企业营业执照复印件;</li>
                                    <li> （2）企业资质 / 2023年度财务报表复印件；</li>
                                    <li>（3）企业海归人才回国工作证明材料；</li>
                                    <li> （4）专利获奖证书等奖项证明复印件;</li>
                                    <li>（5）技术成果推广应用证明材料（包括合同、用户使用效果证明）；</li>
                                </ul></Col>
                            <Col span={9} className="upload_list">
                                <ul>
                                    <li className="list_title">2、项目介绍</li>
                                    <li>（1）项目PPT、WORD等相关简介</li>
                                    <li> （2）项目重大工程技术获奖证明复印件;</li>
                                    <li> （3）技术成果鉴定（评价）证明复印件；</li>
                                    <li> （4）国家或省部级重大技术工程项目证明材料;</li>
                                </ul></Col></Row>
                        <Row gutter={24} type="flex">
                            <Col span={24} className="upload_list">
                                <ul>
                                    <li className="list_title">3、企业负责人证明材料：</li>
                                    <li>（1）身份证复印件；</li>
                                    <li>（2）最高学历、学位证书、专业技术职务证书复印件；</li>
                                    <li>（3）本人主要参与的技术成果所获专利证明的复印件；</li>
                                    <li>（4）本人获奖或主要参与的工程技术项目等各类获奖证明（包括获奖人员名单排序）复印件;</li>
                                    <li>（5）发表的重要论文、论著首页（封面）复印件；</li>
                                    <li>（6）本人主要参与的技术成果所取得的经济、社会效益的有关证明。</li></ul>
                            </Col>
                        </Row>
                        <br />
                        <h4>附件列表：（单个附件文件大小不能超过30MB）</h4>
                        <Form.Item
                            style={{ marginTop: 8, marginLeft: 80, width: "70%" }}>                          
                            {files.map(({ file_name, file_path, id }) => {
                                return (<Row gutter={24} type="flex">
                                    <Col gutter={20}><Icon type="paper-clip" /><a href={`http://${UPLOAD_SERVER_HOST}${file_path}`} style={{ color: "blue",marginLeft:8 }} target="_blank">{file_name}</a></Col>
                                    <Col>
                                        <Popconfirm
                                            title="确认要删除此附件吗？"
                                            onConfirm={onRemoveFile.later(id)}
                                            okText="确认"
                                            cancelText="取消"
                                        >
                                            <p className="link"><Icon type="delete" title="删除附件" /></p>
                                        </Popconfirm></Col>
                                </Row>)
                            })}

                            <Upload
                                style={{ minWidth: "160px", color: "blue", marginTop: 20 }}
                                name="files"
                                onFinish={onUploadFileFinish.later("enclosure")}
                                action={uploadUrl}
                            >
                                <Button><Icon type="upload" /> 上传</Button>
                            </Upload>

                        </Form.Item>

                        <Divider>项目申报人信息</Divider>
                        <Row gutter={24} type="flex">
                            <Col span={8} >
                                <Form.Item label="姓名" type="flex">
                                    {data.declarant_name}
                                </Form.Item>
                            </Col>
                            <Col span={6} >
                                <Form.Item label="电话" type="flex">
                                    {info.account}
                                </Form.Item>
                            </Col>
                        </Row>
                        <p style={{ textAlign: "center", marginTop: 30 }}>
                            <Button type="primary" onClick={onSubmit} loading={loading}>修改</Button>
                            <Button onClick={hide} style={{ marginLeft: 20 }}>取消</Button>
                        </p>
                    </Panel>
                </Collapse>
            </Form>
        </Modal>
    );
})

export default App;